// 商品与搜索：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 移动商品
export const mobileProduct = Object.freeze({
  "mobile.product.back": "返回",
  "mobile.product.home": "首頁",
  "mobile.product.share": "分享",
  "mobile.product.inspected": "已驗貨",
  "mobile.product.viewInspectionImages": "查看驗貨圖片",
  "mobile.product.remaining": "餘{count}",
  "mobile.product.minimumOrder": "起訂",
  "mobile.product.approximately": "約",
  "mobile.product.sourceLocation": "貨源地",
  "mobile.product.batch": "批次",
  "mobile.product.days": "天",
  "mobile.product.deliveryDays": "交貨天數",
  "mobile.product.sectionNavigation": "商品詳情頁內導航",
  "mobile.product.parameters": "參數",
  "mobile.product.specification": "規格書",
  "mobile.product.contactInfo": "聯絡方式",
  "mobile.product.substitutes": "替代產品",
  "mobile.product.parameterInfo": "參數資料",
  "mobile.product.basicParameters": "基礎參數",
  "mobile.product.brand": "品牌",
  "mobile.product.partNumber": "料號",
  "mobile.product.copyPartNumber": "複製料號",
  "mobile.product.batchDc": "批次（DC）",
  "mobile.product.manufacturer": "廠家",
  "mobile.product.validityPeriod": "有效期",
  "mobile.product.originProof": "原產地證明",
  "mobile.product.yes": "有",
  "mobile.product.no": "無",
  "mobile.product.condition": "貨物情況",
  "mobile.product.physicalSpecs": "物理規格",
  "mobile.product.weight": "重量",
  "mobile.product.dimensions": "尺寸",
  "mobile.product.length": "長度",
  "mobile.product.width": "寬度",
  "mobile.product.height": "高度",
  "mobile.product.categoryAttributes": "分類屬性",
  "mobile.product.productCategory": "產品分類",
  "mobile.product.aiAnswer": "先搜 AI 解答",
  "mobile.product.specificationPdf": "規格書 PDF",
  "mobile.product.loading": "載入中",
  "mobile.product.preview": "點擊預覽",
  "mobile.product.downloadSpecification": "下載規格書",
  "mobile.product.download": "下載",
  "mobile.product.noSpecification": "暫無規格書",
  "mobile.product.viewNegotiatorProfile": "查看談判人主頁",
  "mobile.product.negotiator": "談判人",
  "mobile.product.chatOnline": "在線溝通",
  "mobile.product.phoneNumber": "聯繫電話",
  "mobile.product.copyPhone": "複製電話",
  "mobile.product.callPhone": "撥打電話",
  "mobile.product.call": "撥打",
  "mobile.product.wechatId": "微信號",
  "mobile.product.copyWechatId": "複製微信號",
  "mobile.product.noSubstitutes": "暫無替代產品",
  "mobile.product.favorited": "已收藏",
  "mobile.product.favorite": "收藏",
  "mobile.product.contact": "聯繫",
  "mobile.product.addToCart": "加入購物車",
  "mobile.product.quickOrder": "快捷下單",
  "mobile.product.contactService": "客服諮詢",
  "mobile.product.submitPurchaseIntent": "提交購買意向",
  "mobile.product.expectedPrice": "期望價格",
  "mobile.product.price": "價格",
  "mobile.product.quantity": "數量",
  "mobile.product.buyerName": "買家姓名",
  "mobile.product.enterBuyerName": "請填寫買家姓名",
  "mobile.product.buyerPhone": "買家流動電話號碼",
  "mobile.product.enterBuyerPhone": "請填寫買家流動電話號碼",
  "mobile.product.deliveryAddress": "交貨地址",
  "mobile.product.enterDeliveryAddress": "請填寫交貨地址",
  "mobile.product.required": "不能為空",
  "mobile.product.referredNegotiator": "推薦談判人",
  "mobile.product.enterNegotiatorPhone": "請填寫推薦談判人流動電話號碼",
  "mobile.product.chooseQuantity": "選擇數量",
  "mobile.product.addedToCart": "成功加入購物車",
  "mobile.product.continueShopping": "繼續選購",
  "mobile.product.goToCart": "去購物車",
  "mobile.product.shareTo": "分享到",
  "mobile.product.cancel": "取消",
  "mobile.product.wechat": "微信",
  "mobile.product.douyin": "抖音",
  "mobile.product.xiaohongshu": "小紅書",
  "mobile.product.weibo": "微博",
  "mobile.product.requiredField": "必填項",
  "mobile.product.enterValidNumber": "請填寫有效的數字",
  "mobile.product.agentService": "客服",
  "mobile.product.online": "在線",
  "productSpecification.loginRequired": "登入後可查看或下載該規格書。",
  "productSpecification.notNow": "暫不登入",
  "productSpecification.accessDenied": "暫無權限查看該規格書。",
  "productSpecification.notFound": "規格書不存在或已被刪除。",
  "mobile.product.notice": "温馨提示",
  "mobile.product.loginRequired": "此時需要先登入才能繼續操作哦",
  "mobile.product.goToLogin": "去登入",
  "mobile.product.keepBrowsing": "再逛逛",
  "mobile.product.verifyIdentityFirst": "請先登入並實名認證後再操作",
  "mobile.product.copySucceeded": "複製成功",
  "mobile.product.copyFailed": "複製失敗",
  "mobile.product.verifyIdentity": "請先實名認證後再操作!",
  "mobile.product.insufficientStock": "當前庫存不足，無法加入購物車",
  "mobile.product.enterQuantity": "請輸入數量",
  "mobile.product.belowMinimumQuantity":
    "加入購物車數量需大於起訂量（{quantity}）",
  "mobile.product.notBoundBuyer": "您不是該商品的綁定用戶，無法加入購物車",
  "mobile.product.confirmBoundPhone": "綁定流動電話號碼確認",
  "mobile.product.boundPhoneQuestion":
    "商品綁定流動電話號碼：{phone}，是您本人使用？",
  "mobile.product.confirm": "確定",
  "mobile.product.purchaseIntentSubmitted":
    "提交訂購意向成功！請等待商務接單！",
  "mobile.product.specificationUrlFailed": "規格書地址獲取失敗，請稍後重試",
  "mobile.product.sharedTo": "分享到：{name}",
});

// 移动搜索
export const mobileSearch = Object.freeze({
  "mobile.search.backHome": "返回首頁",
  "mobile.search.ai": "先搜AI",
  "mobile.search.all": "綜合",
  "mobile.search.products": "商品",
  "mobile.search.wiki": "百科",
  "mobile.search.wikiResults": "百科結果",
  "mobile.search.productResults": "商品結果",
  "mobile.search.allResults": "綜合結果",
  "mobile.search.resultCount": "共 {count} 條",
  "mobile.search.searching": "搜索中",
  "mobile.search.noResults": "暫無相關結果",
  "mobile.search.publisher": "發佈者：{name}",
  "mobile.search.userPublished": "用戶發佈",
  "mobile.search.priceOnRequest": "價格面議",
  "mobile.search.stockUnconfirmed": "庫存待確認",
  "mobile.search.viewDetails": "查看詳情",
  "mobile.search.recentSearches": "最近搜索",
  "mobile.search.clearHistory": "清空搜索歷史",
  "mobile.search.wikiSearchFailed": "百科搜索失敗，請稍後重試",
  "mobile.search.searchFailed": "搜索失敗，請稍後重試",
  "mobile.search.productList": "商品列表",
  "mobile.search.searchProducts": "搜索商品",
  "mobile.search.sales": "銷量",
  "mobile.search.price": "價格",
});

// 桌面商品
export const desktopProduct = Object.freeze({
  "pcProduct.seller": "賣家",
  "pcProduct.back": "返回",
  "pcProduct.mainImage": "商品主圖",
  "pcProduct.thumbnail": "縮略圖",
  "pcProduct.inspected": "已驗貨",
  "pcProduct.share": "轉發分享",
  "pcProduct.wechat": "微信",
  "pcProduct.weibo": "微博",
  "pcProduct.douyin": "抖音",
  "pcProduct.xiaohongshu": "小紅書",
  "pcProduct.details": "產品詳情",
  "pcProduct.validity": "有效期",
  "pcProduct.manufacturer": "廠家",
  "pcProduct.deliveryDays": "交貨天數",
  "pcProduct.daysValue": "{count}天",
  "pcProduct.weight": "重量",
  "pcProduct.originProof": "原產地證明",
  "pcProduct.yes": "有",
  "pcProduct.no": "無",
  "pcProduct.dimensions": "尺寸",
  "pcProduct.applications": "應用標籤",
  "pcProduct.category": "產品分類",
  "pcProduct.categoryAttributes": "分類屬性",
  "pcProduct.contactDetails": "聯絡方式",
  "pcProduct.contactPerson": "聯絡人",
  "pcProduct.negotiatorSuffix": "（談判人）",
  "pcProduct.phone": "聯繫電話",
  "pcProduct.wechatId": "微信號",
  "pcProduct.consultNegotiator": "在線諮詢談判人",
  "pcProduct.specification": "規格書",
  "pcProduct.specLoading": "規格書載入中",
  "pcProduct.downloadSpec": "下載規格書",
  "pcProduct.fullScreen": "全屏查看",
  "pcProduct.substitutes": "替代產品",
  "pcProduct.brand": "品牌",
  "pcProduct.partNumber": "料號",
  "pcProduct.price": "價格",
  "pcProduct.approximately": "約",
  "pcProduct.minimumOrderSuffix": "起訂",
  "pcProduct.stock": "庫存",
  "pcProduct.goodsCondition": "貨物情況",
  "pcProduct.specPartNumber": "規格料號",
  "pcProduct.batch": "批次",
  "pcProduct.sourceLocation": "貨源地",
  "pcProduct.minimumOrder": "起訂量",
  "pcProduct.quantity": "數量",
  "pcProduct.favorite": "收藏",
  "pcProduct.contact": "聯繫",
  "pcProduct.addToCart": "加入購物車",
  "pcProduct.quickOrder": "快捷下單",
  "pcProduct.agentService": "客服諮詢",
  "pcProduct.addedToCart": "成功加入購物車",
  "pcProduct.addedToCartDetail": "商品已添加到您的購物車",
  "pcProduct.productImage": "商品圖片",
  "pcProduct.continueShopping": "繼續選購",
  "pcProduct.checkoutCart": "去購物車結算",
  "pcProduct.required": "必填項",
  "pcProduct.validNumber": "請填寫有效的數字",
  "pcProduct.aiAnswers": "先搜AI解答",
  "pcProduct.loginAndVerifyFirst": "請先登入並且實名認證後再操作!",
  "pcProduct.copySuccess": "複製成功",
  "pcProduct.copyFailed": "複製失敗",
  "pcProduct.confirmBoundPhone":
    "商品綁定流動電話號碼：{phone}，是您本人使用？",
  "pcProduct.boundPhoneTitle": "綁定流動電話號碼確認",
  "pcProduct.confirm": "確定",
  "pcProduct.cancel": "取消",
  "pcProduct.verifyFirst": "請先實名認證後再操作!",
  "pcProduct.notBoundBuyer": "您不是該商品的綁定用戶，無法加入購物車",
  "pcProduct.insufficientStock": "當前庫存不足，無法加入購物車",
  "pcProduct.belowMinimum": "加入購物車數量需大於起訂量（{quantity}）",
});

// 桌面搜索
export const desktopSearch = Object.freeze({
  "pcSearch.placeholder": "搜索料號、名稱、品牌、百科、供需",
  "pcSearch.clear": "清空",
  "pcSearch.search": "先搜一下",
  "pcSearch.ai": "先搜AI",
  "pcSearch.all": "綜合",
  "pcSearch.product": "商品",
  "pcSearch.wiki": "百科",
  "pcSearch.supplyDemand": "供需",
  "pcSearch.bidding": "競標",
  "pcSearch.index": "指數",
  "pcSearch.user": "用戶",
  "pcSearch.resultSummary": "找到 {count} 條與“{keyword}”相關的{type}結果",
  "pcSearch.enterKeyword": "輸入關鍵詞後可搜索全站內容",
  "pcSearch.priceOnRequest": "價格面議",
  "pcSearch.stockPending": "庫存待確認",
  "pcSearch.stockCount": "庫存 {count}{unit}",
  "pcSearch.viewDetails": "查看詳情",
  "pcSearch.pagination": "搜索結果分頁",
  "pcSearch.previousPage": "上一頁",
  "pcSearch.nextPage": "下一頁",
  "pcSearch.searching": "正在搜索...",
  "pcSearch.noResults": "沒有找到匹配結果",
  "pcSearch.tryAnotherKeyword":
    "可以換成料號、品牌、百科名稱或商品名稱再試一次。",
  "pcSearch.enterSearchText": "請輸入搜索內容",
  "pcSearch.productQueryFailed": "商品查詢介面暫時異常，請稍後再試。",
  "pcSearch.wikiQueryFailed": "百科查詢介面暫時異常，請稍後再試。",
  "pcSearch.wikiEntry": "百科詞條",
  "pcSearch.communityWiki": "用戶百科",
  "pcSearch.datasheetAvailable": "已收錄規格書",
  "pcSearch.communityPublished": "用戶發佈",
  "pcSearch.publishedBy": "發佈者：{name}",
  "pcSearch.skHynix": "海力士",
  "pcSearch.datasheet": "規格書",
});

// 规格书
export const specification = Object.freeze({
  "pcSpecification.title": "規格書管理",
  "pcSpecification.subtitle": "查看當前賬號已下載的百科規格書",
  "pcSpecification.refresh": "刷新",
  "pcSpecification.empty": "暫無已下載的規格書",
  "pcSpecification.partNumber": "規格書料號",
  "pcSpecification.points": "消耗積分",
  "pcSpecification.downloadedAt": "下載時間",
  "pcSpecification.expiresAt": "到期時間",
  "pcSpecification.status": "狀態",
  "pcSpecification.valid": "有效",
  "pcSpecification.expired": "已失效",
  "pcSpecification.actions": "操作",
  "pcSpecification.viewWiki": "查看百科",
  "pcSpecification.loadFailed": "獲取已下載規格書失敗，請稍後重試",
  "pcSpecification.missingWiki": "未找到該規格書對應的百科詞條",
});

// 手机端业务流程：固定界面文案。
export const mobileWorkflow = Object.freeze({
  "goodsLibrary.selectVideo": "請選擇影片檔案",
  "goodsLibrary.confirmCreate": "確認新增",
  "goodsLibrary.enterCode": "請輸入商品編號",
  "goodsLibrary.imageUrlHint": "請輸入或上傳商品圖片網址",
  "goodsLibrary.particleInformation": "顆粒資訊",
  "goodsLibrary.wafer": "晶圓",
  "goodsLibrary.yield": "良率",
  "goodsLibrary.stack": "疊層",
  "goodsLibrary.priceStock": "價格庫存",
  "goodsLibrary.mediaDescription": "媒體與描述",
  "goodsLibrary.wideImage": "寬屏展示圖片",
  "goodsLibrary.wideImageHint": "請輸入或上傳寬屏展示圖片網址",
  "goodsLibrary.gallery": "圖冊圖片",
  "goodsLibrary.galleryHint": "請輸入或上傳圖冊圖片，多張以逗號分隔",
  "goodsLibrary.videoUrl": "影片網址",
  "goodsLibrary.videoHint": "請輸入或上傳影片網址",
  "goodsLibrary.sellingPoints": "賣點描述",
  "goodsLibrary.sellingPointsHint": "請輸入商品賣點",
  "goodsLibrary.removeFile": "移除檔案",
  "goodsLibrary.chooseFromLibrary": "從檔案庫選擇",
  "goodsLibrary.allowedBuyersHint": "按手機號碼加入允許購買此商品的買家",
  "goodsLibrary.closeSaleRange": "關閉修改可售範圍視窗",
  "goodsLibrary.newBuyerPhone": "新增買家手機號碼",
  "goodsLibrary.addPhonesHint": "輸入手機號碼後點擊新增，可連續加入多位買家",
  "goodsLibrary.allowedBuyers": "以下買家可購買目前商品",
  "goodsLibrary.noBuyerPhones": "暫未加入買家手機號碼",
  "goodsLibrary.addPhoneFirst": "請至少加入一個手機號碼",
  "goodsLibrary.videoLimit": "支援影片，最大{size}MB",
  "goodsLibrary.imageLimit": "支援圖片，最大{size}MB",
  "goodsLibrary.enterFileUrl": "請輸入或上傳檔案網址",
  "goodsLibrary.fileSizeLimit": "檔案大小不能超過{size}MB",
  "goodsLibrary.pageSizeOption": "每頁{size}項",
  "goodsLibrary.bindProduct": "綁定商品",
  "goodsLibrary.offSale": "下架",
  "goodsLibrary.onSale": "上架",
  "goodsLibrary.soldOut": "已售完",
  "goodsLibrary.platformUnlisted": "平台下架",
  "goodsLibrary.storeUnavailable": "商店無法使用",
  "goodsLibrary.supplierUnlisted": "供應商下架",
  "goodsLibrary.supplierDisabled": "供應商已停用",
  "goodsLibrary.missingId": "未取得商品ID",
  "goodsLibrary.enterName": "請輸入商品名稱",
  "goodsLibrary.created": "新增成功",
  "goodsLibrary.listed": "已上架",
  "goodsLibrary.chooseExcelFormat": "請選擇xls或xlsx檔案",
  "goodsLibrary.chooseExcelFirst": "請先選擇Excel檔案",
  "goodsLibrary.enterPageRange": "請輸入1至{total}之間的頁碼",
  "goodsLibrary.overview": "商品總覽",
  "goodsLibrary.title": "商品資料庫",
  "goodsLibrary.refresh": "重新載入商品資料",
  "goodsLibrary.currentResults": "目前結果",
  "goodsLibrary.activeOnPage": "本頁已上架",
  "goodsLibrary.inactiveOnPage": "本頁已下架",
  "goodsLibrary.searchName": "商品名稱搜尋",
  "goodsLibrary.searchCode": "商品編號搜尋",
  "goodsLibrary.filterStatus": "商品狀態篩選",
  "goodsLibrary.salePrice": "銷售價",
  "goodsLibrary.loading": "正在載入商品",
  "goodsLibrary.loadFailed": "商品資料載入失敗",
  "goodsLibrary.noResults": "暫無符合條件的商品",
  "goodsLibrary.create": "新增商品",
  "goodsLibrary.pagination": "商品列表分頁",
  "goodsLibrary.page": "頁",
  "goodsLibrary.jumpToPage": "跳至頁碼",
  "goodsLibrary.actions": "商品操作",
  "goodsLibrary.edit": "修改商品",
  "goodsLibrary.listProduct": "上架商品",
  "goodsLibrary.pageSize": "每頁顯示數量",
  "goodsLibrary.pageNumber": "頁碼",
  "goodsLibrary.excelImport": "Excel 匯入",
  "goodsLibrary.importTitle": "批次匯入商品資料",
  "goodsLibrary.chooseExcel": "選擇 Excel 檔案",
  "goodsLibrary.excelFormats": "支援 xls、xlsx 格式",
  "goodsLibrary.importCompleted": "匯入完成",
  "goodsLibrary.imported": "成功匯入",
  "goodsLibrary.productCountUnit": "項商品",
  "goodsLibrary.duplicatePartNumbers": "重複料號",
  "goodsLibrary.startImport": "開始匯入",
});

// PC界面显示文案；不改动业务原值。
export const productFixedFacts = Object.freeze({
  "pcProduct.whiteLabel": "白牌",
  "pcProduct.factorySealedBox": "原箱原封",
  "pcProduct.originalFactoryPackaging": "原廠原包",
  "pcProduct.nonFactoryPackaging": "非原廠原包",
  "pcProduct.conditionSeparator": "，",
  "pcProduct.quantityWithUnit": "{count}{unit}",
  "pcProduct.unitPiece": "個",
  "pcProduct.unitItem": "件",
  "pcProduct.unitBox": "箱",
  "pcProduct.unitSet": "套",
});

// 页面受控选项与属性显示；原始业务值保持不变。
export const attributeDisplayFollowup = Object.freeze({
  "pcProduct.unitMilligram": "毫克",
  "pcProduct.unitKilogram": "千克",
  "pcProduct.unitKilogramColloquial": "公斤",
  "pcProduct.attributePackage": "封裝",
  "pcProduct.attributeColor": "顏色",
  "pcProduct.colorBlue": "藍色",
  "pcProduct.colorRed": "紅色",
  "pcProduct.colorBlack": "黑色",
  "pcProduct.colorWhite": "白色",
  "pcProduct.factoryOpenedBox": "原箱已拆封",
});

export const goodsFeedback = Object.freeze({
  "goodsFeedback.confirmList": "確認上架「{name}」嗎？",
  "goodsFeedback.confirmDeleteGoods": "刪除後無法復原，確認刪除「{name}」嗎？",
});


// 搜索结果展示：PC 与移动端共用。
export const searchResultsPresentation = Object.freeze({
  "searchResults.aiTitle": "先搜 AI",
  "searchResults.basicInfo": "基本資訊",
  "searchResults.executionComplete": "執行完成",
  "searchResults.candidateHint": "目前輸入可能缺少後綴或存在字元混淆，請核對以下實際候選型號。",
  "searchResults.partialIntro": "已找到此料號的部分資料，",
  "searchResults.remainingUnknown": "其餘參數待確認",
  "searchResults.compareHeading": "對比參數",
  "searchResults.noAlternatives": "暫未取得有依據的替代候選，無法確認可直接替換。",
  "searchResults.questionAnswer": "{model}：{parameter}為 {value}。",
  "searchResults.sources": "資料來源",
  "searchResults.difference": "差異",
  "searchResults.parameterName": "名稱",
  "searchResults.parameterDescription": "描述",
  "searchResults.parameterLabel": "料號參數",
  "searchResults.noImage": "暫無圖片",
  "searchResults.aiTemporaryResult": "AI 臨時結果",
  "searchResults.standardAnswerSource": "標準答案 · AI說明待確認",
  "searchResults.wikiPartialUnavailable": "部分百科來源暫時無法載入，已顯示可用結果。",
  "searchResults.noPrice": "價格待確認",
  "searchResults.noStock": "庫存待確認",
  "searchResults.aiEmptyTitle": "暫未找到可靠資料",
  "searchResults.aiEmptyDescription": "暫未取得「{keyword}」的有效資料，無法提供準確的參數資訊。",
  "searchResults.aiLoginTitle": "登入後查看 AI 解讀",
  "searchResults.aiLoginDescription": "登入後可查詢此關鍵詞的 AI 解讀。",
  "searchResults.aiLogin": "前往登入",
  "searchResults.checkLabel": "建議核對",
  "searchResults.checkModel": "完整料號",
  "searchResults.checkModelDescription": "檢查是否存在漏字、空格或字元混淆。",
  "searchResults.checkBrand": "品牌資訊",
  "searchResults.checkBrandDescription": "補充製造商品牌，有助縮小查找範圍。",
  "searchResults.checkSuffix": "型號後綴",
  "searchResults.checkSuffixDescription": "核對晶片絲印或完整訂貨型號。",

  "searchResults.platformProducts": "平台商品",
  "searchResults.similarProducts": "相似商品",
  "searchResults.popularSearches": "大家都在搜",
  "searchResults.weeklyProducts": "本週熱料",
  "searchResults.matchedCount": "符合目前搜尋 · {count} 件",
  "searchResults.viewAll": "查看全部商品（共 {count} 件）",
  "searchResults.moreProducts": "更多商品",
  "searchResults.similarHint": "同品牌或相近料號，替代使用前請核對規格與相容性。",
  "searchResults.similarLoading": "正在查詢相似商品…",
  "searchResults.noSimilar": "暫未找到其他相似商品",
  "searchResults.fallbackPopular": "暫無熱搜資料",
  "searchResults.popularLoading": "正在載入熱搜…",
  "searchResults.noPopular": "暫無熱搜資料",
  "searchResults.popularityUnavailable": "熱度資料暫時無法載入",
  "searchResults.goodsLoading": "正在載入商品…",
  "searchResults.noRecommended": "暫無推薦商品",
  "searchResults.expandAi": "展開完整 AI 解讀",
  "searchResults.collapseAi": "收起 AI 解讀",
  "searchResults.tryAlso": "也可試試",
  "searchResults.noDetail": "暫無詳情",
  "searchResults.purchase": "去購買",
  "searchResults.viewProduct": "查看商品",
  "searchResults.wikiUnavailable": "百科服務暫時無法載入，請稍後重試",
});

export const searchDataPresentation = Object.freeze({
  "searchData.currentModel": "目前型號",
  "searchData.compatibility": "相容結論",
  "searchData.selectionAdvice": "選型參考",
  "searchData.selectModel": "查詢此型號",
  "searchData.coverageStart": "資料開始累積於 {time}（北京時間）",

  "searchData.model": "料號",
  "searchData.brand": "品牌",
  "searchData.ambiguous": "暫時無法確定完整型號，請確認您要查找的料號。",
  "searchData.conflict": "資料存在差異",
  "searchData.unknown": "待確認",
  "searchData.parameter": "參數",
  "searchData.comparison": "型號參數對比表，可橫向捲動",
  "searchData.alternatives": "候選型號對比",
  "searchData.verified": "已驗證可直接替代",
  "searchData.candidate": "候選，適用條件及相容性待核對",
  "searchData.similarUnavailable": "相似商品暫時無法載入，請稍後重試",
  "searchData.hotProducts": "本週熱料",
  "searchData.field.brand": "品牌",
  "searchData.field.productType": "產品類型",
  "searchData.field.capacity": "顆粒容量",
  "searchData.field.bitWidth": "位寬",
  "searchData.field.speed": "頻率 / 速率",
  "searchData.field.frequency": "頻率",
  "searchData.field.package": "封裝 / 球位",
  "searchData.field.ball": "球位",
  "searchData.field.voltage": "工作電壓",
  "searchData.field.pins": "引腳數量",
  "searchData.field.ddr": "DDR世代",
  "searchData.field.density": "密度",
  "searchData.field.organization": "組織",
  "searchData.field.yield": "良率",
  "searchData.field.pinout": "引腳定義",
  "searchData.field.timing": "時序",
  "searchData.field.ballPitch": "焊球間距",
  "searchData.field.controller": "主控相容條件",
  "searchData.field.pcbValidation": "PCB驗證",
  "searchData.source.mall": "平台商品",
  "searchData.source.erp": "ERP錄入",
  "searchData.source.partNumber": "料號庫",
  "searchData.source.knowledge": "知識庫",
  "searchData.source.rule": "規則解析",
  "searchData.source.reviewed": "已審核資料",
  "searchData.source.specification": "規格書",
  "searchData.review.recorded": "平台錄入",
  "searchData.review.parsed": "解析結果",
  "searchData.review.approved": "審核通過",
});

export const messages = Object.freeze({
  ...searchDataPresentation,
  ...searchResultsPresentation,
  ...goodsFeedback,
  ...attributeDisplayFollowup,
  ...productFixedFacts,
  ...mobileWorkflow,
  "goodsRecognition.examples":
    "例一：M321RAJA0MB0-CWM usd 4350.0*500 pcs,  25+ NON CN , 1-2days\n例二：公司現貨 月底衝量優惠 歡迎實單查詢 KLM4G1FETE-B041  25+  12800",
  ...mobileProduct,
  ...mobileSearch,
  ...desktopProduct,
  ...desktopSearch,
  ...specification,
});
